import React from 'react';
import { H2 } from '../../../components';

import css from './SectionBenefits.module.css';
import classNames from 'classnames';
import {
  Account,
  ClientSupport,
  Communicate,
  Dates,
  ExploreArtists,
  Hours48,
  Invoice,
  PersonalDetails,
  Quotes,
  SecurePayment,
} from '../../../assets/iconImages';
import { lazyLoadWithDimensions } from '../../../util/uiHelpers';

const Image = props => {
  const { alt, ...rest } = props;

  return <img {...rest} alt={alt} />;
};

const LazyImage = lazyLoadWithDimensions(Image, {
  loadAfterInitialRendering: 3000,
  maxWidth: '50px',
  maxHeight: '50px',
});

const benefitItems = [
  {
    img: ExploreArtists,
    text: 'HowItWorksPage.benefits.exploreArtistsText',
  },
  {
    img: Quotes,
    text: 'HowItWorksPage.benefits.quoteText',
  },
  {
    img: PersonalDetails,
    text: 'HowItWorksPage.benefits.personalDetailsText',
  },
  {
    img: Communicate,
    text: 'HowItWorksPage.benefits.communicateText',
  },
  {
    img: SecurePayment,
    text: 'HowItWorksPage.benefits.securePaymentText',
  },
  {
    img: Invoice,
    text: 'HowItWorksPage.benefits.invoiceText',
  },
  {
    img: Hours48,
    text: 'HowItWorksPage.benefits.freeCancellationText',
  },
  {
    img: ClientSupport,
    text: 'HowItWorksPage.benefits.supportText',
  },
  {
    img: Account,
    text: 'HowItWorksPage.benefits.freeAccountText',
  },
  {
    img: Dates,
    text: 'HowItWorksPage.benefits.datesText',
  },
];

const SectionBenefits = props => {
  const { intl, className, titleClassName } = props;

  return (
    <div className={classNames(className, css.root)}>
      <H2 className={titleClassName}>
        {intl.formatMessage(
          { id: 'HowItWorks.benefitsHeading' },
          {
            marketplace: (
              <span className={css.marketplaceColoredText}>
                {intl.formatMessage({ id: 'General.marketplace' })}
              </span>
            ),
          }
        )}
      </H2>
      <div className={css.benefitsWrapper}>
        {benefitItems.map(item => (
          <React.Fragment key={item.text}>
            <div key={item.img} className={css.benefit}>
              <LazyImage className={css.image} src={item.img} alt="" />
              <span>
                <span>{intl.formatMessage({ id: item.text }, { b: text => <b>{text}</b> })}</span>
              </span>
            </div>
            <hr className={css.divider} />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default SectionBenefits;
